import type { ICustomerMfeNotesCall } from '@servicetitan/contactcenter-agent-inbox-mfe-loader';
import useInboxState from '@modules/InboxModule/hooks/useInboxState';
import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';
import { liveCallSid } from '../lib/liveCallSid';
import { toNotesCall } from '../lib/notesCall';
import useTasks from './useTasks';

/**
 * The notes call for a task: present only while the task is selected and its
 * call is live by Create Customer's rule, otherwise undefined. The state
 * snapshots are reactive, so a customer linked or cleared mid-call, or a
 * hang-up, reaches the caller on the next render.
 *
 * @param taskId The task to test; defaults to the selected task.
 */
export function useNotesCall(
  taskId?: string,
): ICustomerMfeNotesCall | undefined {
  const { selectedTaskId } = useInboxState();
  const { taskById } = useTasks();
  const { callList } = usePhoneState();

  const id = taskId ?? selectedTaskId;
  const sid = liveCallSid(id, { selectedTaskId, taskById, callList });
  const task = sid ? taskById[sid] : undefined;

  return task && sid ? toNotesCall(task, sid) : undefined;
}

export default useNotesCall;
